import React from 'react';
import { Texto } from '../Texto';
export var BlockWeb = function (_a) {
    var collaboratorName = _a.collaboratorName, align = _a.align, fontSize = _a.fontSize, bold = _a.bold;
    return (React.createElement("div", { style: { width: '100%', textAlign: align } },
        React.createElement(Texto, { texto: collaboratorName ? "WEB - ".concat(collaboratorName) : 'WEB', align: align, fontSize: fontSize, bold: bold })));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockWeb.tsx
// module id = 496
// module chunks = 0